// Contests are often embedded in an iframe on the owner's own page, so a plain
// window.location.href would only navigate the frame and leave the host page
// sitting there. Walk out to the top window instead.
function navigate(url) {
  try {
    if (window.top && window.top !== window.self) {
      // Settable cross-origin; reading it back would throw, so we don't.
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    // Parent on another origin blocked the assignment: fall through to the
    // named-target form, which the browser resolves without us touching the
    // parent's location object.
  }

  try {
    if (window.top !== window.self && window.open(url, "_top")) return;
  } catch (e) {
    // Blocked as well; last resort is navigating whatever frame we are in.
  }

  window.location.href = url;
}

// A cross-origin frame may navigate the top window only while the click's user
// activation is still live — roughly five seconds in Chrome. Keep delaySeconds
// well under that or the redirect is dropped with nothing but a console warning.
function redirectTop(url, delaySeconds) {
  if (!url) return;

  const wait = Number(delaySeconds) || 0;
  if (wait > 0) {
    setTimeout(() => navigate(url), wait * 1000);
    return;
  }

  navigate(url);
}

export default redirectTop;
